import { useGetClientAccessGroupsQuery } from 'rtk/query/apis/clients';

export type AccessGroupOption = { label: string; value: string };

type Params = {
  destinationClientId?: string;
  initialAccessGroupOptions: AccessGroupOption[];
  skip: boolean;
};

export const useDestinationAccessGroups = ({ destinationClientId, initialAccessGroupOptions, skip }: Params) => {
  const { data } = useGetClientAccessGroupsQuery(
    { clientId: destinationClientId || '' },
    { skip: skip || !destinationClientId },
  );

  if (skip || !destinationClientId) {
    return initialAccessGroupOptions;
  }

  return (
    data?.accessGroups.map((accessGroup) => ({
      label: accessGroup.name,
      value: accessGroup.id,
    })) || []
  );
};
